import { Action } from 'react-fetching-library';

export const getTranslatorList: Action = {
  method: 'GET',
  endpoint: 'items/traducteurs',
};
